import React from 'react'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import { Model } from '@morningtrain/react-resources'
import { PeriodFilter, SelectedDepartmentFilter } from 'support/filters'
import moment from 'moment'
import LineChartLoader from 'widgets/charts/RevenueChartLoader'
import { Can } from '@morningtrain/react-auth'
import PeriodFilterSyncedWithPage from "support/filters/PeriodFilterSyncedWithPage";
import CookieFilter from "support/filters/CookieFilter";

export default function RevenueChartDashboardWidget () {
  return (
    <Can permission='api.dashboard.revenue_development'>
      <Widget>
        <Translator namespace='dashboard.revenue_chart'>
          <Model resourceName='dashboard' operationName='revenue_development'>
            <CookieFilter name='period' cookieKey='page.filters.periodDashboard' />
            <SelectedDepartmentFilter />

            <div className='pt-8 pb-6 sm:pt-12 sm:pb-10'>
              <UI.CardHeader>
                <UI.SecondaryHeading>
                  <Translation name='title' />
                </UI.SecondaryHeading>
                <PeriodFilterSyncedWithPage
                  cookieName={'page.filters.periodDashboard'}
                  selectors={['yesterday', 'today', 'this_week', 'this_month', 'this_year']}
                />
              </UI.CardHeader>

              <UI.Legend className='mb-2'>
                <UI.LegendItem color='bg-primary-500'>Omsætning</UI.LegendItem>
                <UI.LegendItem color='bg-error'>Forecast</UI.LegendItem>
              </UI.Legend>

              <div className='w-full h-96'>
                <LineChartLoader />
              </div>
            </div>

          </Model>
        </Translator>
      </Widget>
    </Can>
  )
}
